const modalsSelector = (state) => state.modals;

export default modalsSelector;
